import type { TourStep } from '@/components/ui/Tour';

export const TOUR_PANEL_READY_ATTRIBUTE = 'data-tour-panel-ready';

export function findTourTargetElement(selectorId: string): Element | null {
  if (!selectorId.trim()) return null;
  return (
    document.getElementById(selectorId) ?? document.querySelector(`[data-tour="${selectorId}"]`)
  );
}

export function isTourStepTargetReady(step: TourStep, target: Element): boolean {
  const rect = target.getBoundingClientRect();
  if (rect.width <= 0 && rect.height <= 0) return false;

  if (!step.waitForPanelReady) return true;

  const panel = target.closest(`[${TOUR_PANEL_READY_ATTRIBUTE}="true"]`);
  if (!panel) return false;

  const panelRect = panel.getBoundingClientRect();
  return panelRect.left < window.innerWidth && panelRect.right > 0;
}

export function isTourStepSelectorReady(step: TourStep): boolean {
  if (!step.selectorId.trim()) return true;
  const target = findTourTargetElement(step.selectorId);
  if (!target) return false;
  return isTourStepTargetReady(step, target);
}
